import { Typography } from "@mui/material";

export default function PendingPayment() {
  return (
    <div>
      <h1>
        <Typography><p style={{alignItem: "center", marginTop: "40px"}}><h4>Tu pago se esta procesando...<br/><br/> Muchas Gracias por tu compra</h4></p></Typography>
      </h1>
    </div>
  );
}